/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetProjectMetricsSummaryPayload,
  GetProjectMetricsSummaryPayload$Outbound,
  GetProjectMetricsSummaryPayload$outboundSchema,
} from "../components/getprojectmetricssummarypayload.js";

export type GetProjectMetricsSummarySecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetProjectMetricsSummarySecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetProjectMetricsSummarySecurity = {
  option1?: GetProjectMetricsSummarySecurityOption1 | undefined;
  option2?: GetProjectMetricsSummarySecurityOption2 | undefined;
};

export type GetProjectMetricsSummaryRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  getProjectMetricsSummaryPayload: GetProjectMetricsSummaryPayload;
};

/** @internal */
export type GetProjectMetricsSummarySecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetProjectMetricsSummarySecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetProjectMetricsSummarySecurityOption1$Outbound,
    GetProjectMetricsSummarySecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getProjectMetricsSummarySecurityOption1ToJSON(
  getProjectMetricsSummarySecurityOption1:
    GetProjectMetricsSummarySecurityOption1,
): string {
  return JSON.stringify(
    GetProjectMetricsSummarySecurityOption1$outboundSchema.parse(
      getProjectMetricsSummarySecurityOption1,
    ),
  );
}

/** @internal */
export type GetProjectMetricsSummarySecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetProjectMetricsSummarySecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetProjectMetricsSummarySecurityOption2$Outbound,
    GetProjectMetricsSummarySecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getProjectMetricsSummarySecurityOption2ToJSON(
  getProjectMetricsSummarySecurityOption2:
    GetProjectMetricsSummarySecurityOption2,
): string {
  return JSON.stringify(
    GetProjectMetricsSummarySecurityOption2$outboundSchema.parse(
      getProjectMetricsSummarySecurityOption2,
    ),
  );
}

/** @internal */
export type GetProjectMetricsSummarySecurity$Outbound = {
  Option1?: GetProjectMetricsSummarySecurityOption1$Outbound | undefined;
  Option2?: GetProjectMetricsSummarySecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetProjectMetricsSummarySecurity$outboundSchema: z.ZodMiniType<
  GetProjectMetricsSummarySecurity$Outbound,
  GetProjectMetricsSummarySecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetProjectMetricsSummarySecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetProjectMetricsSummarySecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getProjectMetricsSummarySecurityToJSON(
  getProjectMetricsSummarySecurity: GetProjectMetricsSummarySecurity,
): string {
  return JSON.stringify(
    GetProjectMetricsSummarySecurity$outboundSchema.parse(
      getProjectMetricsSummarySecurity,
    ),
  );
}

/** @internal */
export type GetProjectMetricsSummaryRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  GetProjectMetricsSummaryPayload: GetProjectMetricsSummaryPayload$Outbound;
};

/** @internal */
export const GetProjectMetricsSummaryRequest$outboundSchema: z.ZodMiniType<
  GetProjectMetricsSummaryRequest$Outbound,
  GetProjectMetricsSummaryRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    getProjectMetricsSummaryPayload:
      GetProjectMetricsSummaryPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      getProjectMetricsSummaryPayload: "GetProjectMetricsSummaryPayload",
    });
  }),
);

export function getProjectMetricsSummaryRequestToJSON(
  getProjectMetricsSummaryRequest: GetProjectMetricsSummaryRequest,
): string {
  return JSON.stringify(
    GetProjectMetricsSummaryRequest$outboundSchema.parse(
      getProjectMetricsSummaryRequest,
    ),
  );
}
